var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#7E7E7E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#7E7E7E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C15.3812 13 14.8516 12.7797 14.4109 12.3391C13.9703 11.8984 13.75 11.3688 13.75 10.75C13.75 10.1312 13.9703 9.60156 14.4109 9.16094C14.8516 8.72031 15.3812 8.5 16 8.5C16.6188 8.5 17.1484 8.72031 17.5891 9.16094C18.0297 9.60156 18.25 10.1312 18.25 10.75C18.25 11.3688 18.0297 11.8984 17.5891 12.3391C17.1484 12.7797 16.6188 13 16 13ZM11.5 17.5V15.925C11.5 15.6062 11.582 15.3133 11.7461 15.0461C11.9102 14.7789 12.1281 14.575 12.4 14.4344C12.9812 14.1438 13.5719 13.9258 14.1719 13.7805C14.7719 13.6352 15.3812 13.5625 16 13.5625C16.6188 13.5625 17.2281 13.6352 17.8281 13.7805C18.4281 13.9258 19.0188 14.1438 19.6 14.4344C19.8719 14.575 20.0898 14.7789 20.2539 15.0461C20.418 15.3133 20.5 15.6062 20.5 15.925V17.5H11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.2f6cebb19fcbe73692f7978c7341981a.svg";
export { ForwardRef as ReactComponent };